export const GET_ALL_TENANTS_START = 'GET_ALL_TENANTS_START';
export const GET_ALL_TENANTS_SUCCESS = 'GET_ALL_TENANTS_SUCCESS';
export const GET_ALL_TENANTS_FAIL = 'GET_ALL_TENANTS_FAIL';

export const ADD_TENANT_START = 'ADD_TENANT_START';
export const ADD_TENANT_SUCCESS = 'ADD_TENANT_SUCCESS';
export const ADD_TENANT_FAIL = 'ADD_TENANT_FAIL';

export const UPDATE_TENANT_START = 'UPDATE_TENANT_START';
export const UPDATE_TENANT_SUCCESS = 'UPDATE_TENANT_SUCCESS';
export const UPDATE_TENANT_FAIL = 'UPDATE_TENANT_FAIL';

export const DELETE_TENANT_START = 'DELETE_TENANT_START';
export const DELETE_TENANT_SUCCESS = 'DELETE_TENANT_SUCCESS';
export const DELETE_TENANT_FAIL = 'DELETE_TENANT_FAIL';
